// src/slices/branchesSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SignUpSessionExpiredState {
  expired: boolean;
}

const initialState: SignUpSessionExpiredState = {
  expired: false
};

const SignUpSessionExpiredSlice = createSlice({
  name: 'expired',
  initialState,
  reducers: {
    setExpired: (
      state: SignUpSessionExpiredState,
      action: PayloadAction<boolean>
    ) => {
      state.expired = action.payload;
    }
  }
});

export const { setExpired } = SignUpSessionExpiredSlice.actions;
export default SignUpSessionExpiredSlice.reducer;
